const getEnvVariable = (name) => {
  const envVar =
    window._env_ && window._env_[name]
      ? // eslint-disable-next-line no-undef
        window._env_[name] || process.env[name]
      : // eslint-disable-next-line no-undef
        process.env[name];
  return envVar;
};

export default getEnvVariable;
